const ANALYTICS_VERSION_KEY = 'analyticsVersion';

function shouldUseLegacyAnalytics(version, { canSeeNew } = {}) {
  return !canSeeNew || version === 'legacy';
}

module.exports = {
  ANALYTICS_VERSION_KEY,
  shouldUseLegacyAnalytics,
};
